import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/china1.jpg',
  './images/B1.webp',
  './images/B2.webp',
  './images/B3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Beijing, the capital of China, is a city where ancient history meets modern innovation.

Top places to visit:

• The Great Wall of China – Hike the iconic wall at Mutianyu or Badaling with breathtaking views.
• The Forbidden City – Explore the largest ancient palace complex in the world.
• Tiananmen Square – Visit the world’s largest city square and nearby museums.
• Temple of Heaven – A stunning religious site where emperors once prayed for good harvests.
• Summer Palace – Enjoy the serene gardens, lakes, and historic pavilions.
• Lama Temple – A beautiful Tibetan Buddhist temple with intricate architecture.
• Beijing Hutongs – Walk or cycle through traditional alleyways to see authentic local life.
• 798 Art District – A creative zone filled with modern art galleries and cafés.
• Wangfujing Street – A vibrant shopping street with fashion and exotic street food.
• Beijing National Stadium (Bird’s Nest) – A modern marvel from the 2008 Olympics.

Beijing also offers diverse cuisine such as Peking Duck, noodle dishes, and hot pot, making it a dream destination for food lovers.`,

    zh: `北京是中国的首都，是一座古老历史与现代科技相融合的城市。

推荐景点：

• 万里长城（慕田峪或八达岭）– 世界著名的古代防御工程，风景壮丽。
• 紫禁城 – 世界上最大的古代宫殿建筑群。
• 天安门广场 – 世界最大的城市广场，旁边有多座博物馆和纪念碑。
• 天坛 – 古代皇帝祭天祈福的地方，建筑宏伟。
• 颐和园 – 湖泊、花园和历史建筑交相辉映。
• 雍和宫 – 精美的藏传佛教寺庙。
• 胡同 – 北京传统巷弄，体验地道市井生活。
• 798艺术区 – 当代艺术和创意文化的集中地。
• 王府井大街 – 热闹的商业街，集购物与小吃于一体。
• 鸟巢 – 2008年奥运会的标志性场馆，建筑独特。

北京还是美食天堂，著名的北京烤鸭、面条、火锅等都值得一试。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/china1.jpg"  className="travel-image2" />
          <img src="./images/B1.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Beijing</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Beijing</h2>
          <p className="carousel-subheading">Discover imperial palaces, ancient alleys, and timeless traditions in the heart of China.</p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc}  className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
